import { Fragment } from "react";
import {
  Alert,
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import BaseLayout from "../../layouts/BaseLayout";
import Timeline from "../../components/ServiceTimeline";
import ServiceCallToActions from "./ServiceCallToActions";
import CopyTextButton from "../../components/CopyTextButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useTreatment from "../../api/useTreatment";
import SendRentalAgreementButton from "./SendRentalAgreementButton";

function ServiceSingle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { api } = useOutletContext();
  const { isLoading, error, data: serviceData, mutate } = useTreatment(id);

  if (error) {
    return (
      <BaseLayout>
        <Alert severity="error">{error.message}</Alert>
      </BaseLayout>
    );
  }

  if (isLoading || !serviceData) {
    return <BaseLayout>Loading...</BaseLayout>;
  }

  const first_arrived_on = serviceData[0]?.fit_on;
  const data =
    serviceData.map((x) => ({ ...x, first_arrived_on })).slice(-1)[0] || {};

  const fitabilityIssue = !data.fitable && data.billing_channel === "cash-pay";

  const showSendRentalAgreementButton =
    data.billing_channel === "cash-pay" && data.rental_agreement_docid === null;
  const showRentalAgreementSent =
    data.billing_channel === "cash-pay" && data.rental_agreement_docid !== null;

  return (
    <BaseLayout>
      <Stack spacing={2}>
        <Typography variant="h3" align="center">
          {data.patient_name}
        </Typography>
        <Box mt={2}>
          <Alert
            variant="outlined"
            severity="info"
            icon={false}
            action={
              <IconButton
                size="small"
                onClick={() => navigate(`/patients/${data.eoc_id}`)}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            }
          >
            Viewing a service item, for patient:
          </Alert>
        </Box>
        {fitabilityIssue && (
          <Alert severity="error">
            Patient cannot be fit: {data.fitable_memo}
          </Alert>
        )}
        {showSendRentalAgreementButton && (
          <SendRentalAgreementButton
            treatId={data.treat_id}
            api={api}
            onSuccess={() => mutate()}
          />
        )}
        {showRentalAgreementSent && (
          <Alert severity="info">Rental Agreement has been sent</Alert>
        )}
        {data.checkout_link && data.billing_channel === "cash-pay" ? (
          <CopyTextButton
            copyText={data.checkout_link}
            label="Payment Link"
            Control={Button}
            controlProps={{
              children: "Copy Payment Link",
              variant: "outlined",
              fullWidth: true,
              size: "large",
            }}
          />
        ) : null}
        <ServiceCallToActions
          cycle={data}
          api={api}
          refresh={() => mutate()}
          actionsDisabled={data.order_status === "postponed"}
        />
        {serviceData.map((d) => {
          return (
            <Fragment key={d.id}>
              <Box sx={{ width: "100%" }} mb={0}>
                <Typography align="center" variant="h5">
                  Unit: {d.serial_num}
                </Typography>
              </Box>
              <Timeline cycle={d} />
            </Fragment>
          );
        })}
      </Stack>
    </BaseLayout>
  );
}

export default ServiceSingle;
